import Products from 'merchandise-lib/constants/Product';
import { HC_0136_SALES_HUB_PROFESSIONAL, HC_0136_SERVICE_HUB_PROFESSIONAL } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { HC_0136_GROUP_PARAMETER_KEY, HC_0136_GROUP_PARAMETER_OPTIONS, HC_0136_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useCompanyDetails } from '../../hooks/useCompanyDetails';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { useHighestProductLevelFromInventory } from '../../v2/hooks/inventory/useHighestProductLevel';
import { useHasApiNameInProductInventory } from '../../v2/hooks/inventory/useProductInventoryLookup';
import { useIsSeatsUser } from '../../v2/hooks/user/useUserInfo';
import { getIsAcceptanceTest } from '../testUtils';
import { logExperimentExposure, useExperimentEffect } from './experimentUtils';
const treatmentKey = HC_0136_TREATMENT_KEY;
export const PROMOTION_MAPPING = {
  [Products.SALES_HUB_PROFESSIONAL]: HC_0136_SALES_HUB_PROFESSIONAL,
  [Products.SERVICE_HUB_PROFESSIONAL]: HC_0136_SERVICE_HUB_PROFESSIONAL
};
export const TRIAL_PROMO_LENGTH = 30 * 24 * 60 * 60 * 1000; // 30 days in ms

export const logHC0136Exposure = () => {
  logExperimentExposure(treatmentKey);
};
const useHC0136EligibilityCondition = apiName => {
  var _companyDetails$compa, _companyDetails$compa2;
  const isAcceptanceTest = getIsAcceptanceTest();
  const hasExperimentsFetchSucceeded = useAppSelector(hasExperimentsFetchSucceededSelector);
  const isAppReady = useGlobalLoading();
  const isInApp = useAppSelector(isAppAuthSelector);
  const {
    companyDetails
  } = useCompanyDetails();
  const hasSeats = useIsSeatsUser();
  const {
    highestProductLevel
  } = useHighestProductLevelFromInventory();
  const {
    hasProductInInventory: hasSuiteStarter
  } = useHasApiNameInProductInventory({
    apiName: Products.CRM_SUITE_STARTER_BUNDLE
  });
  const isFreeOrStarter = highestProductLevel && ['FREE', 'STARTER'].includes(highestProductLevel);
  const isConditionMet = Boolean(isAppReady && hasExperimentsFetchSucceeded && !isAcceptanceTest && isInApp && hasSeats && isFreeOrStarter && !hasSuiteStarter && (companyDetails === null || companyDetails === void 0 || (_companyDetails$compa = companyDetails.companyDetails) === null || _companyDetails$compa === void 0 ? void 0 : _companyDetails$compa.companySize) && (companyDetails === null || companyDetails === void 0 || (_companyDetails$compa2 = companyDetails.companyDetails) === null || _companyDetails$compa2 === void 0 ? void 0 : _companyDetails$compa2.companySize) <= 10 && PROMOTION_MAPPING[apiName]);
  return {
    isConditionMet
  };
};
export const useHC0136ExperimentEffect = apiName => {
  const eligibilityCondition = useHC0136EligibilityCondition(apiName);
  return useExperimentEffect({
    treatmentKey: HC_0136_TREATMENT_KEY,
    groupParameterKey: HC_0136_GROUP_PARAMETER_KEY,
    groupParameterOptions: HC_0136_GROUP_PARAMETER_OPTIONS,
    experimentEligibilityCondition: () => eligibilityCondition,
    shouldLogExposure: false
  });
};